@if (!isSinglePiecesCake) {
  @if (!discount) {
    <div class="from-price ws-product-detail__price">
      {{
        'cakeBuilder.productInfo.fromPrice' | translate: {
          price: price | currencyFormat: '',
          currency: currency
        }
      }}
    </div>
  }

  @if (discount) {
    <div class="from-price ws-product-detail__price">
      {{ 'common.from' | translate }}
      <span class="text-muted-warm text-cross-out">{{ price | currencyFormat }}</span>&nbsp;
      <span [class.text-discount]="!discountTheme.color()"
            [style.color]="discountTheme.color()">{{ price | tryToDiscountPrice: discount : currency }}</span>
    </div>
  }
}

@if (isSinglePiecesCake) {
  @if (!discount) {
    <div class="from-price ws-product-detail__price">
      {{ price | currencyFormat: currency }} {{ unitName }}
    </div>
  }

  @if (discount) {
    <div class="from-price ws-product-detail__price">
      <span class="text-muted-warm text-cross-out">{{ price | currencyFormat }}</span>&nbsp;
      <span [class.text-discount]="!discountTheme.color()"
            [style.color]="discountTheme.color()">{{ price | tryToDiscountPrice: discount : currency }}</span>&nbsp;{{ unitName }}
    </div>
  }
}
